import { useEffect } from 'react';
import { useConfigStore } from '@/store/configStore/configStore';
import { ConfigState } from '@/store/configStore/configState';

export const useConfigUpdate = (configData: Partial<ConfigState>) => {
    const updateConfig = useConfigStore((state) => state.updateConfig);
    useEffect(() => {
        updateConfig(configData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
